import { call } from 'redux-saga/effects'
import { APIS } from '../../_config'
import { CallApi } from '../api/callApi'
import { ErrorResponse, SuccessResponse } from '../api/apiTypes'
import { trackError } from '../../utils/analytics/rumTracking'

export function* getKpiImpact<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(CallApi.POST, APIS.KPI.KPI_IMPACTS, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch KPI data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getKpiImpact', action: action?.type })
    }
}

export function* getAvgMetric<P, R>(action: {
    type: string
    payload: {
        literal: string
        group_name?: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const resp = yield call(CallApi.POST, APIS.KPI.AVG_METRIC, action.payload)
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ Fixed: Always provide proper error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch average metric data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getAvgMetric', action: action?.type })
    }
}

export function* getAvgNetRevnuePerPocPerday<P, R>(action: { type: string; payload: any; onSuccess: (response: SuccessResponse<R>) => void; onError: (response: ErrorResponse<R>) => void }): any {
    try {
        const resp = yield call(
            CallApi.POST,
            APIS.KPI.AVG_NET_REVENUE_PER_POC_PER_DAY, // static value, api need to be changed
            action.payload,
        )
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ Fixed: Always provide proper error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch average revenue data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'getAvgNetRevnuePerPocPerday', action: action?.type })
    }
}

export function* avgKpiPerIntervention<P, R>(action: {
    type: string
    payload: {
        literal: string
        group_name?: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const { literal } = action.payload
        const resp = yield call(
            CallApi.GET,
            APIS.KPI.AVG_KPI_PER_INTERVENTION(literal), // static value, api need to be changed
            action.payload,
            false,
        )
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ Fixed: Always provide proper error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch KPI per intervention data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'avgKpiPerIntervention', action: action?.type })
    }
}

export function* interventonCombination<P, R>(action: {
    type: string
    payload: {
        literal: string
        group_name?: string
    }
    onSuccess: (response: SuccessResponse<R>) => void
    onError: (response: ErrorResponse<R>) => void
}): any {
    try {
        const { literal } = action.payload
        const resp = yield call(
            CallApi.GET,
            APIS.KPI.INTERVENTION_COMBINATION(literal), // static value, api need to be changed
            action.payload,
            false,
        )
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action?.onSuccess(resp.data as SuccessResponse<R>)
        } else {
            action?.onError(resp.data as ErrorResponse<R>)
        }
    } catch (e: any) {
        // action?.onError(e.data)
        // ✅ Fixed: Always provide proper error object
        action?.onError(
            e?.data || {
                message: e?.message || 'Failed to fetch intervention combination data',
                status_code: e?.status || 500,
                success: false,
            },
        )
        trackError(e instanceof Error ? e : new Error(e?.message || 'Saga error'), { saga: 'interventonCombination', action: action?.type })
    }
}
